<div class="xcdrs-dialog">
    <div mat-dialog-title class="dialog-header">
        <h1 class="title" [translate]="title"></h1>
        <button mat-button mat-icon-button mat-dialog-close class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="search-field-container">
      <xcdrs-search-field class="remove-maxwidth" (search)="onSearchInputChange($event)"></xcdrs-search-field>
    </div>
    <div mat-dialog-content infiniteScroll [infiniteScrollThrottle]="100" (scrolled)="onScroll()"
        [scrollWindow]="false">
        <ul class="organizations-list" *ngIf="!loading">
            <li class="list-item" *ngFor="let item of items">
                <mat-checkbox *ngIf="(data.type == SubTypeEnum.RequestCatalog) ||
                data.type == tabKeyEnum.Requests ||  data.type == tabKeyEnum.EspSurveys || data.type == tabKeyEnum.EspRecords"
                    (change)="onCheckboxChanged($event)" [checked]="isSelected(item.id)" [value]="item.id">
                </mat-checkbox>
                <mat-radio-button
                    *ngIf="data.type == SubTypeEnum.REQUESTS || data.type == SubTypeEnum.REQUEST || data.type == SubTypeEnum.TOPIC || data.type == tabKeyEnum.SocialMedia || data.type == SubTypeEnum.DASHBOARD"
                    [checked]="isSelected(item.id)" (change)="onRadioBtnChange($event)" [value]="item.id">
                </mat-radio-button>
                <div class="info">
                    <span class="org-name">{{item.name}}</span>
                </div>
            </li>
        </ul>
        <mat-spinner style="margin: 1.5rem auto" *ngIf="loading"></mat-spinner>
    </div>
    <div mat-dialog-actions>
        <div class="d-flex flex-row flex-grow-1">
            <button (click)="closeDialog()" mat-flat-button class="flex-grow-1" color="primary" [disabled]="loading">
                <span *ngIf="!loading" translate="ExdrCommon.Done"></span>
                <span *ngIf="loading" translate="ExdrCommon.Loading"></span>
            </button>
        </div>
    </div>
</div>
